<span class="tag is-hoverable is-link is-light is-rounded">{{ reactionEmoji }} <small class="is-size-7">{{count ??
    0}}</small></span>&nbsp;